import gql from 'graphql-tag';

export default gql`
    mutation ResumeStages($input: ResumeStagesInput) {
        resumeStages(input: $input) {
            errors
        }
    }
`;
